<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("iotcomms_master_account.title", 2) }}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="iotcommsFilter"
          :options="iotcommsOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:iotcommsFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc("sip.view.state", 1) }}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="stateFilter"
          :options="stateOptions"
          multiple
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:stateFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row class="mb-2 justify-content-end mx-2">
        <b-form-checkbox
          id="filter-ivr"
          name="filter-ivr"
          @change="(val) => $emit('update:ivrFilter', val)"
          :checked="ivrFilter"
          value="1"
          unchecked-value="0"
          class="my-1 text-capitalize"
          switch
        >
          IVR
        </b-form-checkbox>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormCheckbox,
    vSelect,
  },
  props: {
    iotcommsOptions: {
      type: Array,
      default: null,
    },
    iotcommsFilter: {
      type: Array,
      default: null,
    },
    stateOptions: {
      type: Array,
      default: null,
    },
    stateFilter: {
      type: Array,
      default: null,
    },
    ivrFilter: {
      type: String,
      default: "1",
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
